import{ConversationModel} from './conversation.model'
import { EmailThreadModel } from './email-thread.model';
import { VoiceConversationModel } from './voice-conversation.model';
export class ConverstionHistoryModel {
    _id?: any;
    uuid: string;
    type: string;
    update_date: Date;
    model: (ConversationModel | EmailThreadModel | VoiceConversationModel);

    constructor(uuid: string, type:string, updated_date: Date, model: (ConversationModel | EmailThreadModel | VoiceConversationModel)){
        this.uuid= uuid;
        this.type= type;
        this.update_date = updated_date;
        this.model = model;
        
    }
        
}